/**
 * Mock data for AssignProjectModal component
 * This will be replaced with real API data
 */

import type { Student, ProjectGroup } from './types'

export const MOCK_GROUPS: ProjectGroup[] = [
  { id: '1', name: '5th Grade - Morning' },
  { id: '2', name: '5th Grade - Afternoon' },
  { id: '3', name: '6th Grade - Morning' },
]

export const MOCK_STUDENTS: Student[] = [
  { id: '1', firstName: 'Amanda', lastName: 'Clark', groupIds: ['1'] },
  { id: '2', firstName: 'Ashley', lastName: 'Walker', groupIds: ['1'] },
  { id: '3', firstName: 'Christopher', lastName: 'Miller', groupIds: ['1', '2'] },
  { id: '4', firstName: 'Daniel', lastName: 'Robinson', groupIds: ['2'] },
  { id: '5', firstName: 'Emily', lastName: 'Davis', groupIds: ['2'] },
  { id: '6', firstName: 'James', lastName: 'Anderson', groupIds: ['2', '3'] },
  { id: '7', firstName: 'Jessica', lastName: 'Martinez', groupIds: ['3'] },
  { id: '8', firstName: 'Matthew', lastName: 'Lewis', groupIds: ['3'] },
  { id: '9', firstName: 'Michael', lastName: 'Johnson', groupIds: ['1', '3'] },
  { id: '10', firstName: 'Sarah', lastName: 'Thompson', groupIds: ['1'] },
  { id: '11', firstName: 'Travis', lastName: 'Orange', groupIds: ['2'] },
]

// Single group scenario for testing auto-selection
export const MOCK_SINGLE_GROUP: ProjectGroup[] = [
  { id: '1', name: '5th Grade - Morning' },
]
